<template>
  <div class="count-down-component"
       :class="[
         `align-${align}`
       ]"
  >
    <div class="item">
      {{ hours }}
    </div>
    <img class="colon"
         :src="require('@/pages/2019/TourLottery/assets/img/colon.png')"
         alt=""
    >
    <div class="item">
      {{ timerData.minutes }}
    </div>
    <img class="colon"
         :src="require('@/pages/2019/TourLottery/assets/img/colon.png')"
         alt=""
    >
    <div class="item">
      {{ timerData.seconds }}
    </div>
  </div>
</template>

<script>
  import CountDown from '@/utils/count-down';

  export default {
    name: 'CountDown',
    data() {
      return {
        timerData: {
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: '00',
        },
      };
    },
    props: {
      start: {
        type: Number,
        required: true,
      },
      end: {
        type: Number,
        required: true,
      },
      align: {
        type: String,
        default: 'right',
        validator(val) {
          return [
            'right',
            'center',
            'left',
          ].includes(val);
        },
      },
    },
    computed: {
      hours() {
        return (parseInt((this.timerData.days * 24), 10) + parseInt(this.timerData.hours, 10));
      },
    },
    methods: {
      initCountDown() {
        new CountDown({
          startTime: this.start,
          endTime: this.end,
          render: (data) => {
            this.timerData = data;
          },
        });
      },
    },
    created() {
      this.initCountDown();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .count-down-component {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    line-height: 1;
    &.align-center {
      justify-content: center;
    }
    &.align-left {
      justify-content: flex-start;
    }
  }

  .item {
    padding: @size-base @size-small;
    display: flex;
    align-items: center;
    font-size: @font-size-large * 2;
    line-height: 1;
    background: url('~@/pages/2019/TourLottery/assets/img/count_down_item.png') no-repeat;
    background-size: 100% 100%;
  }

  .colon {
    margin: 0 @size-small;
    width: 12px;
    height: 50px;
  }
</style>
